/*
 * Public API Surface of microapp
 */
export * from './lib/microapp-eps.module';
export * from './pages/microapp-eps.home.component';
export * from './pages/microapp-eps.home.module';
